/**
 * @time 2024/05/30
 * @author 邻家大龙猫
 * @description 创建多语言配置文件
 * */


import en from './en/index'
import cn from './zh-CN/index'


const langs = {
  "zh-CN": cn,
  "en": en,
}


export default langs


// WEBPACK FOOTER //
// ./src/config/lang/index.js